import { h, defineComponent } from 'vue';
import ImageDrawing from '@/ui/components/inspectionReport/questions/ImageDrawing';

interface ImageAssetProps {
  photo: Record<string, string>;
  isThumbnail?: boolean;
}

export const ImageAssetPdf = defineComponent<ImageAssetProps>({
  name: 'ImageAssetPdf',
  props: ['photo', 'isThumbnail'],
  setup(props, ctx) {
    return function render() {
      return h(ImageDrawing, {
        props: {
          image: props.photo.image || null,
          drawing: props.photo.drawing || null,
          isThumbnail: props.isThumbnail || false,
        },
        // @ts-ignore
        on: ctx.listeners,
      });
    };
  },
});
